import { createSelector } from 'reselect';
import { getEnrichedForecastsForActingCalendarUser } from 'routes/forecast/redux/modules/forecast.selectors';
import type { EnrichedForecast } from 'routes/forecast/types/forecast';
import { isBetweenDates } from 'utils/date-helper';
import { getDates } from './calendar.filter';

/**
 * Returns all enriched forecasts that are, uh, forecasted to be worked on
 * during the dates shown in calendar.
 *
 * This should be refactored for speed, and featureset.
 *
 * It must be made a lot smarter about when to propose forecasts based on the
 * forecast's progress, other "locked in" estimates, and the actual remaining time.
 *
 * It should be explored how the `suggested_hours` can follow this concept too.
 * Forecasts & actual recorded memories predicted to the same project should likely merge.
 *
 * A simplified data model based on forecasts + memories is likely the better choice,
 * considering future expansions to the "suggested inline" concept. For example,
 * vacations & sick-days from BambooHR could work.
 */
export const getProposedForecastsByDay = createSelector(
  [getEnrichedForecastsForActingCalendarUser, getDates],
  (forecasts, dates) => {
    return dates.reduce<Record<string, Array<EnrichedForecast>>>((map, date) => {
      const forecastsOnDate = forecasts.filter(forecast => {
        const { from, to } = forecast;
        const withinRange = isBetweenDates(date, from, to);

        return withinRange && !forecast.meta.isDone;
      });
      map[date] = forecastsOnDate;
      return map;
    }, {});
  }
);
